(function () {
  if (window.kkShareReady) return;
  window.kkShareReady = true;

  var menu = null;
  var backdrop = null;
  var activeBtn = null;
  var activeData = null;
  var sheetQuery = window.matchMedia('(max-width: 767px)');
  var moreIcon =
    '<svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" focusable="false"><circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/></svg>';

  function shareData(btn) {
    return {
      url: btn.getAttribute('data-share-url') || window.location.href,
      title: btn.getAttribute('data-share-title') || document.title,
      image: btn.getAttribute('data-share-image') || '',
    };
  }

  function fill(root, data) {
    var tokens = {
      __URL__: encodeURIComponent(data.url),
      __TITLE__: encodeURIComponent(data.title),
      __IMAGE__: encodeURIComponent(data.image),
    };
    root.querySelectorAll('a[href]').forEach(function (link) {
      var href = link.getAttribute('href');
      Object.keys(tokens).forEach(function (key) {
        href = href.split(key).join(tokens[key]);
      });
      link.setAttribute('href', href);
    });
    root.querySelectorAll('[data-kk-share-copy]').forEach(function (copy) {
      copy.setAttribute('data-kk-share-copy', data.url);
    });
    if (!data.image) {
      var pin = root.querySelector('.kk-share-links__item--pinterest');
      if (pin && pin.parentNode) pin.parentNode.hidden = true;
    }
  }

  function closeMenu() {
    if (!menu || menu.hidden) return;
    menu.hidden = true;
    if (backdrop) backdrop.hidden = true;
    if (activeBtn) activeBtn.setAttribute('aria-expanded', 'false');
    activeBtn = null;
  }

  function canNativeShare() {
    if (!navigator.share) return false;
    var ua = navigator.userAgent || '';
    if (/Windows NT|CrOS/i.test(ua) && !/Mobile/i.test(ua)) return false;
    var touchMac = /Macintosh/i.test(ua) && navigator.maxTouchPoints > 1;
    return /Android|iPhone|iPad|iPod/i.test(ua) || touchMac;
  }

  function isSheet() {
    return !!menu && menu.classList.contains('kk-share-menu--sheet');
  }

  function place(btn) {
    var sheet = sheetQuery.matches;
    menu.classList.toggle('kk-share-menu--sheet', sheet);
    if (sheet) {
      menu.style.left = '';
      menu.style.top = '';
      menu.hidden = false;
      backdrop.hidden = false;
      return;
    }
    var rect = btn.getBoundingClientRect();
    var gap = 8;
    menu.style.visibility = 'hidden';
    menu.hidden = false;
    var width = menu.offsetWidth;
    var height = menu.offsetHeight;
    var left = Math.min(Math.max(8, rect.right - width), window.innerWidth - width - 8);
    var top = rect.bottom + gap;
    if (top + height > window.innerHeight - 8) top = Math.max(8, rect.top - height - gap);
    menu.style.left = left + 'px';
    menu.style.top = top + 'px';
    menu.style.visibility = '';
  }

  function openMenu(btn) {
    var template = document.getElementById('KKShareTemplate');
    if (!template) return;
    if (!menu) {
      menu = document.createElement('div');
      menu.className = 'kk-share-menu';
      menu.setAttribute('role', 'dialog');
      menu.setAttribute('aria-label', 'Share');
      menu.hidden = true;
      backdrop = document.createElement('div');
      backdrop.className = 'kk-share-backdrop';
      backdrop.hidden = true;
      document.body.appendChild(backdrop);
      document.body.appendChild(menu);
    }
    var data = shareData(btn);
    var content = template.content.cloneNode(true);
    fill(content, data);
    menu.innerHTML =
      '<p class="kk-share-menu__title">Share</p>' +
      '<p class="kk-share-menu__name"></p>';
    menu.querySelector('.kk-share-menu__name').textContent = data.title;
    menu.appendChild(content);
    if (canNativeShare()) {
      var list = menu.querySelector('.kk-share-links');
      if (list) {
        var item = document.createElement('li');
        item.innerHTML =
          '<button type="button" class="kk-share-links__item kk-share-links__item--more" data-kk-share-native aria-label="More share options" title="More">' +
          moreIcon +
          '</button>';
        list.appendChild(item);
      }
    }
    menu.classList.toggle('kk-share-menu--premium', !!btn.closest('.kk-premium'));
    activeBtn = btn;
    activeData = data;
    btn.setAttribute('aria-expanded', 'true');
    place(btn);
    var first = menu.querySelector('a, button');
    if (first && !isSheet()) first.focus({ preventScroll: true });
  }

  function copyFallback(text) {
    var field = document.createElement('textarea');
    field.value = text;
    field.setAttribute('readonly', '');
    field.style.position = 'fixed';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    try {
      document.execCommand('copy');
    } catch (e) {}
    field.remove();
  }

  function copyLink(url, btn) {
    function done() {
      btn.classList.add('is-copied');
      btn.setAttribute('aria-label', 'Link copied');
      clearTimeout(btn._kkCopyTimer);
      btn._kkCopyTimer = setTimeout(function () {
        btn.classList.remove('is-copied');
        btn.setAttribute('aria-label', 'Copy link');
      }, 1800);
    }
    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url).then(done, function () {
        copyFallback(url);
        done();
      });
    } else {
      copyFallback(url);
      done();
    }
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-kk-share]');
    if (btn) {
      event.preventDefault();
      event.stopPropagation();
      if (activeBtn === btn) {
        closeMenu();
        return;
      }
      closeMenu();
      openMenu(btn);
      return;
    }

    if (event.target.closest('[data-kk-share-native]')) {
      event.preventDefault();
      var nativeData = activeData;
      closeMenu();
      if (nativeData && navigator.share) {
        navigator.share({ title: nativeData.title, url: nativeData.url }).catch(function () {});
      }
      return;
    }

    var copy = event.target.closest('[data-kk-share-copy]');
    if (copy) {
      event.preventDefault();
      copyLink(copy.getAttribute('data-kk-share-copy') || window.location.href, copy);
      return;
    }

    if (!menu || menu.hidden) return;
    if (!menu.contains(event.target)) {
      closeMenu();
    } else if (event.target.closest('a')) {
      setTimeout(closeMenu, 0);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !menu || menu.hidden) return;
    var btn = activeBtn;
    closeMenu();
    if (btn) btn.focus();
  });

  var lastWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    closeMenu();
  });
  window.addEventListener(
    'scroll',
    function () {
      if (!isSheet()) closeMenu();
    },
    { passive: true }
  );
})();
